import { FC, useCallback, useMemo, useState } from "react";
import { Box, DialogActions, DialogContent } from "@material-ui/core";
import { closeDrawer } from "actions/drawerActions";
import { useDispatch } from "react-redux";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { TableColumnSettings } from "componentsNew/elements/TableColumnSettings";
import { useCustomDrawerStyles } from "../styles";
import { shiftRecordsUpdateFilters } from "actions/shiftTrackerActions";
import { SHIFT_RECORD_TABLE_HADER_FILTER_COLUMNS } from "pages/ShiftReports/tableData";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { defaultRecordFilters } from "store/initialStates";

interface ShiftTrackerTableSettingsDrawerContentProps {}

export const ShiftTrackerTableSettingsDrawerContent: FC<
  ShiftTrackerTableSettingsDrawerContentProps
> = () => {
  const classes = useCustomDrawerStyles();
  const dispatch = useDispatch();
  const { recordListFilters, hasSecondDriver } = useTypeSelectors((state) => state.dasBoard);
  const [activeCols, setActiveCols] = useState<string[]>(recordListFilters?.activeColumns || []);

  const filterColumns = useMemo(
    () =>
      hasSecondDriver
        ? SHIFT_RECORD_TABLE_HADER_FILTER_COLUMNS
        : SHIFT_RECORD_TABLE_HADER_FILTER_COLUMNS.map((item) => ({
            ...item,
            subList: item.subList?.filter((child) => child.name !== "Helper"),
          })),
    [hasSecondDriver],
  );

  const closenModal = () => dispatch(closeDrawer());

  const handleTogglePaths = useCallback((paths: string[]) => {
    if (!paths.length) return;
    setActiveCols((prev) => {
      const allSelected = paths.every((path) => prev.includes(path));
      if (allSelected) return prev.filter((path) => !paths.includes(path));
      return prev.concat(paths.filter((path) => !prev.includes(path)));
    });
  }, []);

  const handleFilterSubmit = () => {
    dispatch(shiftRecordsUpdateFilters({ activeColumns: activeCols }));
    closenModal();
  };

  const handleReset = () => {
    dispatch(
      shiftRecordsUpdateFilters({
        activeColumns: defaultRecordFilters.activeColumns,
      }),
    );
    closenModal();
  };

  return (
    <>
      <DialogContent className={classes.drawerContent}>
        <TableColumnSettings
          items={filterColumns}
          activeCols={activeCols}
          onTogglePaths={handleTogglePaths}
        />
      </DialogContent>
      <DialogActions className={classes.actionSection}>
        <Box className={classes.actionButtons}>
          <Box className={classes.actionButtons}>
            <Box className={classes.actionButtonsLeft}>
              <CustomButton buttonText={"Save"} onClick={handleFilterSubmit} variant="contained" />
              <CustomButton buttonText={"Cancel"} onClick={closenModal} variant="text" />
            </Box>
            <CustomButton buttonText={"Reset"} onClick={handleReset} variant="text" />
          </Box>
        </Box>
      </DialogActions>
    </>
  );
};
